import { motion } from 'framer-motion';
import { LEAGUE_ORDER, getLeagueConfig } from './league-tokens';
import { LeagueBadge } from './LeagueBadge';
import { cn } from '../ui/utils';

export function LeagueProgressBar({ currentLeague, selectedLeague, onLeagueClick }) {
  const selected = selectedLeague || currentLeague;

  return (
    <div className="grid grid-cols-11 items-end gap-1 sm:gap-2">
      {LEAGUE_ORDER.map((leagueId, idx) => {
        const cfg = getLeagueConfig(leagueId);
        const isCurrent = leagueId === currentLeague;
        const isSelected = leagueId === selected;
        const Component = onLeagueClick ? motion.button : motion.div;

        return (
          <Component
            key={leagueId}
            type={onLeagueClick ? 'button' : undefined}
            onClick={onLeagueClick ? () => onLeagueClick(leagueId) : undefined}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.05 * idx, ease: 'easeOut' }}
            whileHover={onLeagueClick ? { scale: 1.06 } : undefined}
            whileTap={onLeagueClick ? { scale: 0.96 } : undefined}
            className={cn(
              'flex w-full flex-col items-center justify-end rounded-xl p-1 transition-colors',
              onLeagueClick && 'cursor-pointer',
              isCurrent && 'border-2',
              !isCurrent && isSelected && 'bg-blue-50/80'
            )}
            style={isCurrent ? { borderColor: cfg.accent } : undefined}
          >
            <div
              className={cn('aspect-square w-full', isCurrent && 'scale-110')}
              style={isCurrent ? { filter: `drop-shadow(0 0 14px ${cfg.accent})` } : undefined}
            >
              <LeagueBadge liga={leagueId} size="fill" />
            </div>
          </Component>
        );
      })}
    </div>
  );
}

export default LeagueProgressBar;
